const state = () => ({
  clients: [],
  client: null,
  selectedPointIds: [],
  newClient: null,
  loyalty: false,
  pagination: {
    totalResults: 0,
    totalPages: 1,
    prevPage: 1,
    currentPage: 1,
    nextPage: 1,
    perPage: 20
  },
});

const getters = {
  clients: (state) => {
    return state.clients;
  },
  client: (state) => {
    return state.client;
  },
  points: (state) => {
    return state.selectedPointIds.map(id => state.client.points.find((p) => p.id === id));
  },
  newClient: (state) => {
    return state.newClient
  },
  loyalty: (state) => {
    return state.loyalty
  },
  clientsPagination: state => {
    return state.pagination;
  },
};

const actions = {
  async fetchClients({ commit, state }, { id, name, currentPage } = {}) {
    const { data, headers } = await this.$http.get(`clients`, {
      params: {
        id,
        name,
        limit: state.pagination.perPage,
        page: currentPage || state.pagination.currentPage
      },
    });
    commit("setClients", { data, headers });
  },
  async fetchClient({ commit }, { id }) {
    const { data } = await this.$http.get(`clients/${id}`, {
      params: {
        type: "id",
      },
    });
    commit("setClient", data);
  },
  async setSelectedPointIds({ commit }, { pointIds }) {
    commit("setSelectedPointIdsMut", pointIds);
  },
  async setNewClient({ commit }, data) {
    commit("setNewClientMut", data);
  },
  async setLoyalty({ commit }, data) {
    commit("setLoyaltyMut", data);
  },
  async createClient({ commit }, { body }) {
    const { data } = await this.$http.post(`clients`, body);
    return data;
  },
  async createClientException({ commit }, { id, installationFee, paymentMethod }) {
    const { data } = await this.$http.post(`clients/${id}/client-exception`, { installationFee, paymentMethod });
    commit('setClientForceAllowCreation', data);
    return data;
  },
  async deleteClientException({ commit }, { id }) {
    const { data } = await this.$http.delete(`clients/${id}/client-exception`);
    commit('setClientForceAllowCreation', data);
    return data;
  }
};

const mutations = {
  setClients(state, { data, headers }) {
    state.clients = data;
    state.pagination.totalResults = +headers["x-total-results"];
    state.pagination.totalPages = +headers["x-total-pages"];
    state.pagination.prevPage = +headers["x-total-pages"];
    state.pagination.currentPage = +headers["x-current-page"];
    state.pagination.nextPage = +headers["x-next-page"];
    state.pagination.perPage = +headers["x-per-page"];
  },
  setClient(state, data) {
    data.points = data.points.filter((d) => d.id !== 0);
    state.client = data;
  },
  setSelectedPointIdsMut(state, data) {
    state.selectedPointIds = data;
  },
  setNewClientMut(state, data) {
    state.newClient = data;
  },
  setLoyaltyMut(state, data) {
    state.loyalty = data;
  },
  setClientForceAllowCreation(state, toggle) {
    if (state.client) {
      state.client.forceAllowCreation = toggle;
    }
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
};
